<template>
    <div class="chart-container">
        <div ref="chart" :style="{ width: '100%', height: height }"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'BaseChart',
    props: {
        options: {
            type: Object,
            required: true
        },
        height: {
            type: String,
            default: '400px'
        }
    },
    data() {
        return {
            chart: null,
            resizeObserver: null
        };
    },
    watch: {
        options: {
            handler(newOptions) {
                if (this.chart && newOptions) {
                    this.chart.setOption(newOptions, true);
                    this.$nextTick(this.handleResize);
                }
            },
            deep: true
        }
    },
    mounted() {
        this.initChart();
        window.addEventListener('resize', this.handleResize);
        this.createResizeObserver();
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
        window.removeEventListener('resize', this.handleResize);
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    },
    methods: {
        initChart() {
            if (this.$refs.chart) {
                this.chart = echarts.init(this.$refs.chart);
                if (this.options) {
                    this.chart.setOption(this.options);
                }
                
                // Escuchar evento de magicType
                this.chart.on('magictypechanged', (params) => {
                    this.$emit('magic-type-changed', params.currentType);
                });
                this.$nextTick(this.handleResize);
            }
        },
        createResizeObserver() {
            if (typeof ResizeObserver === 'undefined' || !this.$refs.chart) return;

            this.resizeObserver = new ResizeObserver(() => {
                this.handleResize();
            });
            this.resizeObserver.observe(this.$refs.chart);
        },
        handleResize() {
            if (this.chart) {
                this.chart.resize();
            }
        }
    }
};
</script>

<style scoped>
.chart-container {
    width: 100%;
}
</style>
